import {
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { useForecastData } from '../hooks/useForecastData'; // Make sure the hook is implemented

const getColor = (index) => {
  const palette = ['#5c001aff', '#513d49ff', '#45b7d1', '#96ceb4', '#feca57'];
  return palette[index % palette.length];
};

export function DashboardSection() {
  const { doughnutData, lineData, locations, isLoading } = useForecastData();

  if (isLoading) {
    return (
      <section className="py-16 px-6 bg-gray-50 text-center">
        <p className="text-lg text-gray-600">Loading weather analytics...</p>
      </section>
    );
  }

  return (
    <section id="dashboard-section" className="py-16 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl mb-4">Flood Susceptibility Index (FSI)  Analytics Dashboard</h2>
          <p className="text-gray-600 text-lg">Real-time insights and 5-day trends</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Doughnut Chart */}
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="mb-6">
              <h3 className="text-xl">Top 5 FSI Risk Locations (Nigeria)</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={doughnutData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={120}
                  paddingAngle={5}
                  dataKey="value"
                >
                  {doughnutData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color || getColor(index)} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

            <div className="mt-6 grid grid-cols-2 gap-4">
              {doughnutData.map((item, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <div
                    className="w-4 h-4 rounded-full"
                    style={{ backgroundColor: item.color || getColor(index) }}
                  ></div>
                  <span className="text-sm">{item.name}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Line Chart */}
          <div className="bg-white p-6 rounded-lg shadow-sm border">
            <div className="mb-6">
              <h3 className="text-xl">5-Day FSI Trends</h3>
            </div>
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={lineData}
              margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time"
                angle={-45}
                textAnchor='end'
                // interval={0}
                />
                <YAxis domain={[0, 1]} />
                <Tooltip />
                {locations.map((location, index) => (
                  <Line
                    key={location}
                    type="monotone"
                    dataKey={location}
                    stroke={getColor(index)}
                    strokeWidth={3}
                    name={location}
                    dot={false}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>

            <div className="mt-6 flex flex-wrap justify-center gap-4">
              {locations.map((location, index) => (
                <div key={index} className="flex items-center space-x-2">
                  <div
                    className="w-4 h-1"
                    style={{ backgroundColor: getColor(index) }}
                  ></div>
                  <span className="text-sm">{location}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
